/*
 SearchManager Module
- Get search parameters from html form
- Update history
- Get cruise search result based on form parameters
- Order it
- Ask DisplayResultManager to render it
 */

import {serializeObject, mergeObject} from './utils/other'
import DisplayResultManager from './displayResultManager'
import OrderingManager from './orderingManager'

const SearchManager = (function(DisplayResultManager, OrderingManager) {
    // ================== VARIABLE ================== //
    var _currentResult;
    var _searchApiUrl;
    var _baseUrl;
    var _firstTime = { 'history': true, 'result': true };

    // ================== CONSTRUCTOR ================== //
    function SearchManager() {
        // Singleton
        if (SearchManager.instance) {
            throw new Error('SearchManager is a singleton. Use SearchManager.instance.');
        }
        // enforces new
        if (!(this instanceof SearchManager)) {
            return new SearchManager();
        }
    };

    // ================== PUBLIC METHOD ================== //
    SearchManager.prototype.initUrl = function(base_url, search_api_url) {
        _baseUrl = base_url;
        _searchApiUrl = search_api_url;
        DisplayResultManager.onPageChange(_onPageChange, this);
        OrderingManager.onOrderingChange(_onOrderingChange, this);
        OrderingManager.init();
    };

    /* Even if first page of results is displaye by python, we launch
       aynchronously a second search to get all results data for
       having better perfs on the first page rendering */
    SearchManager.prototype.executeForFirstResults = function(search_state) {
       var all_form_param = serializeObject(_get_search_form_fields());
       var params = mergeObject(all_form_param, search_state);
       params['page'] = '';
       _setHistory(params);
       //_getFirstResult(_searchApiUrl + "?" + _serializeParam(parameters));
    };

    SearchManager.prototype.execute = function(parameters, endCallback) {
        _setHistory(parameters);
        //_getResult(_searchApiUrl + "?" + _serializeParam(parameters), endCallback);
    };

    // ================== PRIVATE METHOD ================== //

    function _get_search_form_fields() {
        return $("#search-form").find('input:not(.not-search-field)');
    }

    function _serialize_search_form() {
        return _get_search_form_fields().serialize();
    }

    // Set in history the actual state of the form
    function _setHistory(param) {
        // Get param, from url and from form.
        var query_dict = mergeObject($.QueryString, param);
        var state = {
            'base_url': _searchApiUrl,
            'query': "?" + $.param(query_dict)
        };

        var url = _baseUrl + (query_dict['destination'] != '' ? query_dict['destination'] + "/" : '') + '?';
        delete query_dict['destination']
        url += $.param(query_dict);

        // If it's the first time, make a replace history instead of a pushstate history.
        if (_firstTime.history) {
            history.replaceState(state, 'title', url);
            _firstTime.history = false;
            location.href = location.href;
            return;
        }
        history.pushState(state, 'title', url);
        location.href = location.href;
    }

    // Set the form value like said in the query
    function _deserialize(query) {
        var pairs, i, keyValuePair, key, value;
        pairs = query.slice(1).split('&');
        for (var i = 0; i < pairs.length; i += 1) {
            keyValuePair = pairs[i].split('=');
            key = decodeURIComponent(keyValuePair[0]);
            value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;
            switch (key) {
                case 'reservation_type':
                    $("[value='" + value + "']")[0].checked = true;
                    break;
                case 'page':
                    $('[name=' + key + ']').val(value);
                    break;
                case 'departure_date':
                    $('[name=' + key + ']').val(value == '' ? null : value).trigger('change.select2')
                    break;
                case 'duration':
                    $('[name=' + key + '][value=' + value + ']').prop('checked', true);
                    break;
                case 'destination':
                    $('.destination-filter')[0].selectOldValue(value);
                    break;
            }
        }
    }

    // Go and get the result on search
    function _getResult(url, endCallback) {
        $.get(url, function(data) {
            if (data != _currentResult) {
                _display(data);
                _currentResult = data;
                _firstTime.result = false;
                if (endCallback)
                    endCallback();
            }
        });
    }

    // Go and get the result on first page load
    // In fact, results are already displayed (by python) but we have to initialize
    // all other things like  _currentResult, cruise_list & co
    function _getFirstResult(url) {
        $.get(url, function(data) {
            _display_first_results(data);
            _currentResult = data;
            _firstTime.result = false; // Don't know if still needed
        });
    }

    // Not really a display since it's already shown
    function _display_first_results(data) {
         var info_data = {
            'destination': data.destination || undefined,
            'sharing_type': data.reservation_type,
            'count': data.results.main.length,
            'page': data.page,
            'counter': data.counter,
        };
        DisplayResultManager.renderFirstResult(data.results.main, info_data);
    }

    // Compute result and display search.
    function _display(data) {
        OrderingManager.orderCruise(data.results.main, data.reservation_type);
        var info_data = {
            'destination': data.destination || undefined,
            'sharing_type': data.reservation_type,
            'count': data.results.main.length,
            'page': data.page,
            'counter': data.counter,
        };
        var other_result = {
            'other_type': data.results.other_type,
            'other_dates': data.results.other_dates,
            'other_destination': data.results.other_destination
        };
        DisplayResultManager.renderSearch(data.results.main, info_data, other_result);
    }

    // Serialize parameters
    function _serializeParam(param) {
        var result = '';
        for (var k in param) {
            result += (result == '' ? '' : '&') + k + '=' + param[k];
        }
        return result;
    }

    // ================== EVENT ================== //
    function _onPageChange() {
        var data = serializeObject($("#search-form"));
        data.ordering = window.searchState.ordering
        _setHistory(data);
    }

    function _onOrderingChange() {
        var data = serializeObject($("#search-form"));
        data.ordering = window.searchState.ordering
        _setHistory(data);
        // _display(_currentResult);
    }

    // ================== WINDOW EVENT ================== //

    // When the user click on the back button. Bring back the old form state and search again
    window.onpopstate = function(event) {
        _deserialize(event.state.query);
        _getResult(event.state.base_url + event.state.query);
    };

    SearchManager.instance = new SearchManager();

    return SearchManager.instance;
})(DisplayResultManager, OrderingManager);

export default SearchManager



// WEBPACK FOOTER //
// ./search/static/search/js/searchManager.js